import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import Nav from "../../Components/Navnew/Nav";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { FaLocationArrow } from 'react-icons/fa';
import {
  IoCheckmarkCircleOutline,
  IoCompassOutline,
  IoGlobeOutline,
  IoLocationOutline,
  IoPeopleOutline,
} from "react-icons/io5";
// Import Swiper styles
import SweetAlert from "react-bootstrap-sweetalert";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";
import { Pagination, Navigation } from "swiper";
import Background from "../../Asset/15.jpg"
var sectionStyle = {
  width: "100%",
  backgroundImage: `url(43873269-da92-4f9c-aa3d-b45fd0084d17.jpg)`,
};

const Home = () => {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate()
  const [tours, setTours] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
  // popular
  const [bookShow, setBookShow] = useState(false);
  const [popular, setPopular] = useState([]);
  const [isLoading3, setIsLoading3] = useState([]);
  const [data, setData]= useState(null)
  // galery
  const [galery, setGalery] = useState(['https://cdn.tripster.ru/thumbs2/bd866670-b5c1-11ee-b8f5-3221ccd796ca.1600x900.jpeg', 'https://people-travels.com/storage/images/d1ZupoLogtRiRdEocPqkc9Kgad6PdahsvbbXathF.webp', 'https://upload.wikimedia.org/wikipedia/commons/f/f6/Nest_One_Tashkent.jpg', 'https://upload.wikimedia.org/wikipedia/commons/e/e2/Milliy_bog.jpg', 'https://t86d9d.p3cdn1.secureserver.net/wp-content/uploads/2023/12/Ark-of-Bukhara-2048x1536.jpeg', 'https://tripplanet.ru/wp-content/uploads/asia/uzbekistan/tashkent/dostoprimechatelnosti-tashkenta.jpg']);
  const [isLoading2, setIsLoading2] = useState([]);
  useEffect(() => {
    fetch("https://tur.web-sayt.uz/api/tours", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl9pZCI6ImJlODdiMjYwLTFhMTEtNDY0MC1iMzdkLTk4ZmI5YzQ5ZmI2NSIsInVzZXJfaWQiOiI2Mzg4ZWU0NWIxMzk5MTU2OWM0ZTdiMzAiLCJpYXQiOjE2NzIwNjYyNzd9.v22ZaaX_ZFrVIlWf6gaF7w1q1U3x0VJxiGYTKpDpeEI",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setTours(data.data.data);
        console.log(data.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(true);
      });
  }, []);
  // popular
  useEffect(() => {
    fetch("https://tur.web-sayt.uz/api/tours/popular", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl9pZCI6ImJlODdiMjYwLTFhMTEtNDY0MC1iMzdkLTk4ZmI5YzQ5ZmI2NSIsInVzZXJfaWQiOiI2Mzg4ZWU0NWIxMzk5MTU2OWM0ZTdiMzAiLCJpYXQiOjE2NzIwNjYyNzd9.v22ZaaX_ZFrVIlWf6gaF7w1q1U3x0VJxiGYTKpDpeEI",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setPopular(data.data.data);
        console.log(data.data.data);
        setIsLoading3(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading3(true);
      });
  }, []);
  const formBtn = (e) => {
    setTimeout(() => {
      setBookShow(false);
    }, 1000);
    e.preventDefault();
    if (e.target[0].value.length > 0 && e.target[1].value.length > 0) {
      let botMessege = `
Здравствуйте, администратор UZTURAGENCY, новое сообщение! 😊%0A
Название тура  : ${data.title_eng}%0A
Имя    👤: ${e.target[0].value}%0A
Фамилия   👤: ${e.target[1].value}%0A
Телефон номер   📧: ${e.target[1].value}%0A
`;
// Tur narxi : ${Number(data.price * 11700).toLocaleString()} so'm             

      let url = `https://api.telegram.org/bot7859889008:AAHIkSdCOwbYoxmTwIble9J2FXlAKES8vRk/sendMessage?chat_id=-4535883531&text=${botMessege}`;
      async function fetchAsync(url) {
        let response = await fetch(url);
        let data = await response.json();
        return data;
      }
      fetchAsync(url);
      e.target[0].value = "";
      e.target[1].value = "";
      e.target[2].value = "";
    } 
  };
  // useEffect(() => {
  //   fetch("https://tur.web-sayt.uz/api/galleries", {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl9pZCI6ImJlODdiMjYwLTFhMTEtNDY0MC1iMzdkLTk4ZmI5YzQ5ZmI2NSIsInVzZXJfaWQiOiI2Mzg4ZWU0NWIxMzk5MTU2OWM0ZTdiMzAiLCJpYXQiOjE2NzIwNjYyNzd9.v22ZaaX_ZFrVIlWf6gaF7w1q1U3x0VJxiGYTKpDpeEI",
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setGalery(data.data.galleries);
  //       console.log(data.data.galleries);
  //       setIsLoading2(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setIsLoading2(true);
  //     });
  // }, []);
  return (
    <div>
         <SweetAlert
        title={t("info")}
        show={bookShow}
        onCancel={() => setBookShow(false)}
        showConfirm={false}
      >
        <div>
          <form onSubmit={formBtn}>
            <input className="form-control" placeholder={t("name")} required />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("surname")}
              required
            />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("number")}
              required
            />
            <button
              className="money glow-on-hover"
              style={{ color: "black", backgrounColor: "white" }}
              onClick={() => {}}
            >
              {t("send")}
            </button>
          </form>
        </div>
      </SweetAlert>
      {/* Mirrored from duruthemes.com/demo/html/travol/index2.html by HTTrack Website Copier/3.x [XR&CO'2014], Tue, 13 Sep 2023 15:40:03 GMT */}

      {/* Global site tag (gtag.js) - Google Analytics */}
      {/* Preloader */}

      {/* Progress scroll totop */}
      <div className="progress-wrap cursor-pointer">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          <i class="fa-solid fa-up"></i>
        </svg>
      </div>
      {/* Navbar */}
      <Nav />
      {/* Slider */}
      <header className="header slider-fade">
      {/* owl-carousel owl-theme */}
        <div className="">
          {/* The opacity on the image is made with "data-overlay-dark="number". You can change it using the numbers 0-9. */}
          <div
            className="item bg-img"
            style={{
              background:
                "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18), transparent 36%), radial-gradient(circle at 80% 22%, rgba(255,255,255,0.12), transparent 32%), linear-gradient(155deg, #2da7dc 0%, #168fc8 45%, #0c8bcb 100%)",
            }}
          >
             <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background:
        "linear-gradient(180deg, rgba(8,44,68,0.26) 0%, rgba(8,44,68,0.32) 100%)",
      zIndex: 1, // Ensures the overlay appears above the background
    }}
  ></div>
            <div className="v-middle caption">
              <div className="container">
                <div className="row align-items-center" style={{ minHeight: "75vh" }}>
                  <div className="col-md-7" style={{ textAlign: "left" }}>
                    <h1 className="hero_text" style={{ marginBottom: "14px", maxWidth: "700px" }}>
                      {t("mekka")}
                    </h1>
                    <p style={{ color: "rgba(255,255,255,0.92)", fontSize: "18px", maxWidth: "640px", marginBottom: "22px" }}>
                      {t("hero_subtitle")}
                    </p>
                    <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                      <a
                        href="#tours"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px 16px",
                          borderRadius: "8px",
                          fontWeight: 700,
                          background: "linear-gradient(135deg, #f7fbff 0%, #dceaf5 100%)",
                          color: "#254252",
                          border: "1px solid rgba(255,255,255,0.75)",
                          textDecoration: "none",
                        }}
                      >
                        {t("hero_btn_services")}
                      </a>
                      <a
                        href="#contacts"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px 16px",
                          borderRadius: "8px",
                          fontWeight: 700,
                          backgroundColor: "rgba(255,255,255,0.16)",
                          color: "#fff",
                          border: "1px solid rgba(255,255,255,0.42)",
                          textDecoration: "none",
                        }}
                      >
                        {t("hero_btn_contact")}
                      </a>
                    </div>
                  </div>
                  <div className="col-md-5" style={{ marginTop: "20px" }}>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div style={{ borderRadius: "12px", background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.25)", padding: "14px 16px", color: "#fff", display: "flex", alignItems: "center", gap: "10px" }}>
                        <IoCompassOutline size={22} />
                        <span>{t("support_item_3")}</span>
                      </div>
                      <div style={{ borderRadius: "12px", background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.25)", padding: "14px 16px", color: "#fff", display: "flex", alignItems: "center", gap: "10px" }}>
                        <IoGlobeOutline size={22} />
                        <span>{t("support_item_2")}</span>
                      </div>
                      <div style={{ borderRadius: "12px", background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.25)", padding: "14px 16px", color: "#fff", display: "flex", alignItems: "center", gap: "10px" }}>
                        <IoPeopleOutline size={22} />
                        <span>{t("support_item_4")}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            className="text-center item bg-img"
            style={{
              backgroundImage: `url(./img/slider/s11.jpg)`,
            }}
          >
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    <h4>{t("lets")}</h4>
                    <h1>
                      {t("explore")} <span>UZTURAGENCY</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <div
            className="text-center item bg-img"
            style={{
              backgroundImage: `url(./img/slider/s12.jpg)`,
            }}
          >
            <div className="v-middle caption">
              <div className="container">
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    <h4>{t("twithus")}</h4>
                    <h1>
                      <span>{t("discover")}</span> {t("woguide")}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </header>
      {/*popular tours */}
      <div className="tours3 section-padding bg-lightnav" id="tours">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">{t("service_directions")}</div>
            </div>
          </div>
          <div className="row">
            {/* tour card */}
            {popular.map((e, i) => (
              <div className="col-md-4 d-flex" style={{marginTop: '20px'}}>
                <div style={{ width: "100%" }}>
                  <div className="card" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <Link to={e._id}>
                    <img src={`${e.img}`} alt={lang === "en" ? e.title_eng : lang === "uz" ? (e.title_uz || e.title_ru) : e.title_ru} />
                    </Link>
                    <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '6px 10px', padding: '8px 10px 0', fontSize: '12px'}}>
                      <div style={{backgroundColor: "#0c8bcb", color: "#fff", borderRadius: '10px', padding: '2px 8px', lineHeight: '1.3'}}>
                        {t("business_tour")}
                      </div>
                      <div style={{display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px'}}>
                        <IoLocationOutline />
                        {e.location}
                      </div>
                    </div>
                    <div className=""> 
                    <div onClick={()=>navigation(`/${e._id}`)} style={{padding: '0 10px', cursor: 'pointer', fontSize: '18px', minHeight: '64px'}}>
                    {lang === "en" && e.title_eng}
                    {lang === "ru" && e.title_ru}
                    {lang === "uz" && (e.title_uz || e.title_ru)}
                    </div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          lang === "en"
                            ? e.description_eng
                            : lang === "uz"
                              ? (e.description_uz || e.description_ru)
                              : e.description_ru,
                      }}
                      style={{padding: '0 10px', cursor: 'pointer', fontSize: '12px', overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, minHeight: '54px'}}
                    >
                    </div>
                    <div style={{ height: "10px", marginTop: "auto" }}></div>
                      </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* simple tours */}

          {/* endsimple_tours */}
        </div>
      </div>
      {/* Numbers */}
      {/* <section className="numbers">
        <div
          className="section-padding bg-img bg-fixed back-position-center absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(https://cdn.tripster.ru/thumbs2/bd866670-b5c1-11ee-b8f5-3221ccd796ca.1600x900.jpeg)`,
          }}
          data-overlay-dark={100}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="item text-center">
                  {" "}
                  <img src="img/arrow1.png" className="tobotm" alt="" />{" "}
                  <span className="icon">
                    <i class="fa-solid fa-plane-circle-check"></i>
                    <i class="fa-solid fa-jet-fighter"></i>
                  </span>
                  <h3 className="count">600</h3>
                  <h6>Flight Booking</h6>
                </div>
              </div>
              <div className="col-md-3">
                <div className="item text-center">
                  {" "}
                  <img src="img/arrow1.png" alt="" />{" "}
                  <span className="icon">
                    <i class="fa-solid fa-house"></i>
                    <i class="fa-solid fa-house"></i>
                  </span>
                  <h3 className="count">250</h3>
                  <h6>Amazing Tour</h6>
                </div>
              </div>
              <div className="col-md-3">
                <div className="item text-center">
                  {" "}
                  <img src="img/arrow1.png" className="tobotm" alt="" />{" "}
                  <span className="icon">
                    <i class="fa-solid fa-ship"></i>
                    <i class="fa-sharp fa-solid fa-ship"></i>
                  </span>
                  <h3 className="count">100</h3>
                  <h6>Cruises Booking</h6>
                </div>
              </div>
              <div className="col-md-3">
                <div className="item text-center">
                  {" "}
                  <span className="icon">
                    <i class="fa-solid fa-ticket"></i>
                    <i class="fa-solid fa-ticket"></i>
                  </span>
                  <h3 className="count">100</h3>
                  <h6>Ticket Booking</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Italy &  France Tours 2 */}
      {/* Banner Tour Video */}
      {/* <section className="dynamic-video-wrapper" data-overlay-dark={3}>
        <video
          width="100%"
          height="100%"
          autoPlay="autoplay"
          muted
          preload="auto"
          loop="loop"
        >
          <source src="img/travel-video.mp4" type="video/mp4" />
        </video>
        <div className="wrap-content v-middle">
          <div className="container">
            <div className="row">
              <div className="col-md-8 offset-md-2">
                <h1>Costa Victoria Cochin</h1>
                <h4>
                  <i className="ti-location-pin" /> Maldives &nbsp;&nbsp;{" "}
                  <i className="ti-timer" /> 4 Days + 3 Nights
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Destination 1 */}
      <section className="section-padding bg-lightnav" id="payment-policy">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="section-subtitle">{t("payment_refund_policy")}</div>
              <div className="section-title">{t("payment_policy_title")}</div>
            </div>
            <div className="col-md-6">
              <div className="p-3 h-100" style={{ border: "1px solid #e9e9e9", borderRadius: "8px", background: "#fff" }}>
                <h5>{t("card_payment_title")}</h5>
                <p className="compliance-text">{t("card_payment_text")}</p>
                <h5 style={{ marginTop: "14px" }}>{t("payment_security_title")}</h5>
                <p className="compliance-text">{t("payment_security_text")}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="p-3 h-100" style={{ border: "1px solid #e9e9e9", borderRadius: "8px", background: "#fff" }}>
                <h5>{t("cancel_title")}</h5>
                <p className="compliance-text">{t("cancel_text")}</p>
                <h5 style={{ marginTop: "14px" }}>{t("visa_mastercard_refund_title")}</h5>
                <p className="compliance-text"><strong>{t("visa_mastercard_refund_notice")}</strong></p>
                <ul className="compliance-list">
                  <li>{t("visa_mastercard_refund_1")}</li>
                  <li>{t("visa_mastercard_refund_2")}</li>
                  <li>{t("visa_mastercard_refund_3")}</li>
                  <li>{t("visa_mastercard_refund_4")}</li>
                  <li>{t("visa_mastercard_refund_5")}</li>
                  <li>{t("visa_mastercard_refund_6")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding" id="terms-of-use">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-subtitle">{t("terms_of_use")}</div>
              <div className="section-title">{t("how_to_order_title")}</div>
              <ul className="compliance-list">
                <li><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("how_to_order_1")}</li>
                <li><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("how_to_order_2")}</li>
                <li><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("how_to_order_3")}</li>
                <li><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("how_to_order_4")}</li>
                <li><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("how_to_order_5")}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-lightnav">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-subtitle">{t("pricing_title")}</div>
              <div className="section-title">{t("pricing_list_title")}</div>
              <ul className="compliance-list">
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_consultation")}</li>
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_route")}</li>
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_guests")}</li>
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_one_day")}</li>
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_coordination")}</li>
                <li style={{ display: "flex", alignItems: "center", gap: "8px" }}><IoCheckmarkCircleOutline color="#0c8bcb" /> {t("price_international")}</li>
              </ul>
              <p className="compliance-text">{t("pricing_disclaimer")}</p>
              <p className="compliance-text">{t("price_not_fixed_note")}</p>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      {/* Clients */}
      {/* <section className="clients">
        <div className="container">
          <div className="row">
            <div className="col-md-7 owl-carousel owl-theme">
              <div className="clients-logo">
                <a href="#0">
                  <img src="img/clients/1.png" alt="" />
                </a>
              </div>
              <div className="clients-logo">
                <a href="#0">
                  <img src="img/clients/2.png" alt="" />
                </a>
              </div>
              <div className="clients-logo">
                <a href="#0">
                  <img src="img/clients/3.png" alt="" />
                </a>
              </div>
              <div className="clients-logo">
                <a href="#0">
                  <img src="img/clients/4.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Footer */}
      <Footer />
      {/* jQuery */}
      {/* Mirrored from duruthemes.com/demo/html/travol/index2.html by HTTrack Website Copier/3.x [XR&CO'2014], Tue, 13 Sep 2023 15:40:07 GMT */}
      </div>
  );
};

export default Home;
